export default __webpack_public_path__ + "static/ruifeng-f4dc5029f2de9ff6e8f151e3c4419227.jpeg";